import { Observable } from 'rxjs';
import { GgAiTroubleshootConnector } from '../data-bindings/ai-troubleshoot/gg-ai-troubleshoot.connector';
import { Injectable } from '@angular/core';
import { GGFaqsAI, GGSapIdWSDTO } from '../components/gg-ai-troubleshoot/gg-ai-troubleshoot.component';

@Injectable({
  providedIn: 'root',
})
export class GgAiTroubleshootService {
  constructor(protected ggAiTroubleshootConnector: GgAiTroubleshootConnector) {}

  getSapIdFromAuidOrSn(auidOrSn: string): Observable<GGSapIdWSDTO> {
    return this.ggAiTroubleshootConnector.getSapIdFromAuidOrSn(auidOrSn);
  }

  getFaqsAI(auidOrSn: string, issueDescription: string): Observable<GGFaqsAI> {
    return this.ggAiTroubleshootConnector.getFaqsAI(auidOrSn, issueDescription);
  }
}
